/* eslint-disable func-names, max-len */
import layout from 'netc-layout';

require.ensure(['scrollmagic-core', 'scrollmagic-gsap'], () => {
  const ScrollMagic = require('scrollmagic-core');
  require('scrollmagic-gsap');

  $(() => {
    if (!$('.quickmow').length) {
      return;
    }

    layout.equaliseHeights('.quickmow .retailer-section .retailer');

    $('.quickmow .btn-custom').unbind('click');

    // init ScrollMagic controller
    const section = new ScrollMagic.Controller();

    // declare ScrollMagic scene variables
    const initDesktop = function () {
      const $fixedProduct = $('.js-fixed-product-details');

      if ($fixedProduct.length) {
        $fixedProduct.show();

        new ScrollMagic.Scene({ triggerElement: '.video-section', triggerHook: 0 })
          .setClassToggle('.js-fixed-product-details', 'open')
          .addTo(section);
      }
    };

    // Initialise navigation.
    setTimeout(() => { initDesktop(); }, 1000);
  });
});
